import { Lock } from "lucide-react";

interface AccessRestrictedProps {
  missing?: string[];
  reason?: string;
}

export function AccessRestricted({ missing, reason }: AccessRestrictedProps) {
  const detail =
    reason ??
    (missing && missing.length > 0
      ? `You need ${missing.length === 1 ? "the" : "one of these"} permission${
          missing.length === 1 ? "" : "s"
        } ${missing.join(", ")} to view this page.`
      : "You do not have permission to view this page.");

  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
        <Lock className="w-8 h-8 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-medium mb-2">Access Restricted</h3>
      <p className="text-sm text-muted-foreground max-w-md">{detail}</p>
    </div>
  );
}
